const methods = {};

module.exports = {
  register: function(name, func) {
    methods[name] = func;
  },
  invoke: function(name, ...args) {
    let method = methods[name];
    if (!method) return;
    method.apply(null, args);
  }
};



// WEBPACK FOOTER //
// ./web/components/toast/Utils.js